import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapModule } from '../bootstrap.module';
import { RouterModule } from '@angular/router';
import { UsersService } from './users.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HttpClientModule } from '@angular/common/http';
import { MatFormFieldModule, MatAutocompleteModule, MatInputModule, MatDatepickerModule } from '@angular/material';
import { UsersListComponent } from './list/list.component';
import { UsersFormComponent } from './form/form.component';

import { UsersListGuard } from './users-list.guard';
import { UsersGuard } from './users.guard';
import { TooltipModule } from 'ngx-bootstrap';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
  imports: [
    CommonModule,
    BootstrapModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatInputModule,
    TooltipModule.forRoot(),
    NgxLoadingModule.forRoot({})
  ],
  declarations: [
    UsersListComponent,
    UsersFormComponent,
    // KeysPipe,
  ],
  exports: [
  ]
})
export class UsersModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: UsersModule,
      providers: [
        UsersService,
        UsersListGuard,
        UsersGuard,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/users.module.ts